// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OC-z","modalContent":"PC-z","header":"QC-z","close":"RC-z"};